import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introimpact() {
  return (
    <section className="intro_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Introduction</h2>
            <p>
              The S.E.L.F App by Project Impact MS is another leap towards a
              utopian future where educational organizations can seamlessly
              operate, improve enrollment, save time, communicate with the
              students beyond the classroom, and monitor the level of emotional
              intelligence – All while fostering operation excellence and
              enhancing the learning experience of students.
            </p>
            <p>
              The idea behind the web app was ingenious, and to bring this
              out-of-the-box app idea to life, Project Impact turned to
              Tekrevol.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto text-center"
          >
            <div className="intro_impact">
              <StaticImage
                src="../../../images/case-studies/impact/intro.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={911}
                height={480}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introimpact;
